// import

import {styled} from 'goober';

import type {PageNode} from 'libs/model';
import {ContentSidebar} from 'modules/App';
import {ShareLinks} from 'modules/Share';
import {BannerImage, Header, Meta, useTOC} from 'modules/Solo';
import {TypeCapture} from 'modules/Type';

import {PageSeo} from './PageSeo';

// types

type Props = {
  page: PageNode;
};

// vars

const services = [
  'twitter',
  'pinterest',
  'facebook',
  'reddit',
  'email',
];

// component

export function PagePage(props: Props) {
  const {page} = props;
  const {meta, clip, more} = page;
  const bodyToc = useTOC(meta.headings, {min: 3, max: 50});
  const sideToc = useTOC(meta.headings, {min: 3, max: 15});

  return (
    <>
      <PageSeo page={page} />
      <BannerImage node={page} />

      <ContentSidebar
        stickySidebar
        content={(
          <Content>
            <BannerImage className="figure" node={page} />
            <Header className="header" node={page} />
            <Meta className="meta" node={page} />

            <TypeCapture className="body clip" html={clip} trim="top" />
            <div className="bodyToc">{bodyToc}</div>
            <TypeCapture className="body more" html={more} trim="end" />

            <ShareLinks className="shares" meta={meta} services={services} />
          </Content>
        )}
        showSidebar={!!sideToc}
        sidebar={(
          <div className="sideToc">{sideToc}</div>
        )}
      />
    </>
  );
}

// styles

const Content = styled('div')`
  .figure {
    margin-bottom: 0.25rem;
  }

  .meta {
    margin-bottom: 1.5rem;
  }

  .shares {
    margin-top: 3rem;
    justify-content: center;
  }

  .bodyToc {
    display: none;
    visibility: hidden;
    margin: 3rem 0;
  }

  @media (max-width: 53.99875em) {
    .bodyToc {
      display: block;
      visibility: visible;
    }
  }
`;
